export function NoiseFilter() {
  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none fixed"
      height="0"
      style={{ position: "absolute", zIndex: 0 }}
      width="0"
    >
      <defs>
        <filter height="100%" id="noiseFilter" width="100%" x="0%" y="0%">
          <feTurbulence
            baseFrequency="2.5"
            numOctaves="4"
            seed="2"
            stitchTiles="stitch"
            type="fractalNoise"
          />
          <feColorMatrix type="saturate" values="0" />
          <feComponentTransfer>
            <feFuncA
              tableValues="0 .02 .03 .04 .05 .06 .07 .08"
              type="discrete"
            />
          </feComponentTransfer>
          <feComposite operator="over" />
        </filter>

        <filter height="100%" id="subtleNoise" width="100%" x="0%" y="0%">
          <feTurbulence
            baseFrequency="3"
            numOctaves="1"
            seed="1"
            stitchTiles="stitch"
            type="fractalNoise"
          />
          <feColorMatrix type="saturate" values="0" />
          <feComponentTransfer>
            <feFuncA tableValues="0 .01 .02 .03 .04" type="discrete" />
          </feComponentTransfer>
        </filter>
      </defs>
    </svg>
  );
}
